<template>
  <DialogTemplate
    @close="$emit('close')"
    @send="$emit('send', {...$event, title: newNotificationTitle})"
    :title="$t('notifications.dialog.compose')"
  >
    <v-card-text>

      <p>{{ $t('notifications.dialog.composeSubtitle') }}</p>

    </v-card-text>

    <v-container>
      <v-row no-gutters>
        <v-col cols="12">
          <v-text-field
            :label="$t('notifications.dialog.title')"
            class="t-admin-compose-title"
            v-model="newNotificationTitle"
            :rules="[value => value.trim().length > 0 || $t('rightsholders.sendNotification.rules.emptyHead')]"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

  </DialogTemplate>
</template>

<script>
import DialogTemplate from "./DialogTemplate";

export default {
  props: {},
  data() {
    return {
      newNotificationTitle: '',
    }
  },
  components: {
    DialogTemplate,
  },
};
</script>